"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TopicListHeader = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TopicListHeader, _Component);

  var _super = _createSuper(TopicListHeader);

  function TopicListHeader() {
    (0, _classCallCheck2.default)(this, TopicListHeader);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(TopicListHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onClick = _this$props.onClick,
          className = _this$props.className,
          iconClassName = _this$props.iconClassName,
          title = _this$props.title,
          topicCount = _this$props.topicCount;
      return (0, _preact.h)("div", {
        className: "topic-curation__header ".concat(className)
      }, (0, _preact.h)("h2", {
        className: "topic-curation__widget-title"
      }, title, " ", "(".concat(topicCount, ")")), (0, _preact.h)(_phrase.default, {
        p: "accessibility_label.toggle_topic_list",
        renderAsText: true
      }, function (accessibilityLabel) {
        return (0, _preact.h)("button", {
          className: "topic-curation__widget-toggle",
          onClick: onClick,
          type: "button",
          "aria-label": accessibilityLabel
        }, (0, _preact.h)("i", {
          className: iconClassName
        }));
      }));
    }
  }]);
  return TopicListHeader;
}(_preact.Component);

exports.default = TopicListHeader;